import Dialog, {
  dialogClasses as muiDialogClasses
} from '@mui/material/Dialog';
import { styled } from '@mui/material/styles';

const MARGIN_TOP_BY_VARIANT = {
  message: 120,
  alert: 120
};

const ALIGN_ITEMS_BY_VARIANT = {
  default: 'center',
  message: 'start',
  alert: 'start'
};

export const DialogRoot = styled(Dialog, {
  name: 'AFDialog',
  shouldForwardProp: prop => prop !== 'size' && prop !== 'variant'
})(({ theme, size, variant }) => ({
  [`& .${muiDialogClasses.paper}`]: {
    maxWidth: theme.sizes?.dialog[size],
    marginTop: MARGIN_TOP_BY_VARIANT[variant],
    boxShadow: theme.shadows[24],
    '&.MuiPaper-outlined': {
      border: 'none'
    }
  },
  [`& .${muiDialogClasses.scrollPaper}`]: {
    alignItems: ALIGN_ITEMS_BY_VARIANT[variant]
  }
}));
